module.exports = __webpack_public_path__ + "img/ValidationReport_8.87f520a5.jpg";